import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import moment from 'moment'
import { Base, BREAD, error } from '@/store/base/module'

const PageConst= {
  ACTION: {
    doBrowse: { api: 'T2010TeacherBasicService.C40501_doBrowse_AtDataTable', input: {}},
    getStudentList: { api: 'T1010StudentBasicService.C40501_getStudentList', input: {}},
    getSubjectList: { api: 'M1020SubjectService.getAllSubjects', input: {}},
    getSchoolYearList: { api: 'M0030SchoolYearNameService.getAcademicYearDropdown', input: {}},
    getAdvisorList: { api: 'T0010UsersService.getAdvisorsDropdown', input: {}},
  },
}

const module = {
  state: {
    PageConst,

    orderBy: {
      order_schedule_date: 'desc',
      order_time_limit_no: 'desc',
    },
    studentList: [],
    subjectList: [],
    schoolYearList: [],
    advisorList: [],

    errorMessage: {},

    detailCSVYearMonth: moment().format('YYYY-MM'),

    csvFileName: '',
  },

  getters: {},

  mutations: {},

  actions: {
    async initState ({ state }) {
      const res = await ApiUtils.postData({
        data: [
          PageConst.ACTION.getSchoolYearList,
          PageConst.ACTION.getAdvisorList,
        ]
      }, false)
      state.schoolYearList = res[0].output
      state.advisorList = res[1].output
    },
    async getStudentList ({ state }, payload) {
      const res = await ApiUtils.postData({
        data: [
          { ...PageConst.ACTION.getStudentList, input: payload  },
        ]
      }, false)
      state.studentList = res[0].output
    },
    async getSubjectList ({ state }, payload) {
      const res = await ApiUtils.postData({
        data: [
          { api: PageConst.ACTION.getSubjectList.api, input: payload }
        ]
      }, false)
      state.subjectList = res[0].output
    },
    async exportCSV ({ state }) {
      const res = await ApiUtils.postData({
        data: [{
          api: 'T2010TeacherBasicService.C40501_exportCSV',
          input: {
            searchInfo: state.searchInfo,
            csvFileName: state.csvFileName,
          }
        }]
      })
      return res[0].output;
    },
    async exportDetailCSV ({ state }) {
      const startDate = moment(state.detailCSVYearMonth, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
      const endDate = moment(state.detailCSVYearMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
      const res = await ApiUtils.postData({
        data: [{
          api: 'T2010TeacherBasicService.C40501_exportDetailCSV',
          input: {
            year_month: state.detailCSVYearMonth,
            start_date: startDate,
            end_date: endDate,
          }
        }]
      })
      return res[0].output;
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
